// extracted by mini-css-extract-plugin
export default {"container":"hp-z","brandName":"ip-z","productName":"jp-z","productNamePdpEnhancements":"kp-z","breakLongProductName":"lp-z"};